module.exports = __webpack_public_path__ + "static/media/nightly.1a9485ec.svg";